module.exports = "/_next/static/images/f1e5126a62551bb9db0cbf4a9836e895-hero-md.jpg";